import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { settings } = useApp();

  useEffect(() => {
    // Check if cookies are enabled in settings (default to true if not set)
    const cookiesEnabled = settings.cookies_enabled === 'true' || settings.cookies_enabled === true || settings.cookies_enabled === undefined;

    if (!cookiesEnabled) return;

    // Zkontrolovat jestli už uživatel dal souhlas
    const consent = localStorage.getItem('gdpr_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, [settings.cookies_enabled]);

  const handleAccept = () => {
    localStorage.setItem('gdpr_consent', 'accepted');
    localStorage.setItem('gdpr_consent_date', new Date().toISOString());
    window.dispatchEvent(new Event('cookie-consent-updated'));
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('gdpr_consent', 'rejected');
    localStorage.setItem('gdpr_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg z-50 border-t border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-1">
              {settings.gdpr_title || 'Souhlas s používáním cookies'}
            </h3>
            <p className="text-sm text-gray-600">
              {settings.gdpr_text || 'Tento web používá cookies pro zlepšení uživatelské zkušenosti. Používáním webu souhlasíte s jejich používáním.'}
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
            >
              {settings.gdpr_button_reject || 'Odmítnout'}
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              {settings.gdpr_button_accept || 'Souhlasím'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
